import { InspectionType } from "types/enums";
import { FiveYearsInspection } from "types/fiveYearsInspection/fiveYearsInspection.type";
import { SixMonthsInspection } from "types/sixMonthsInspection/sixMonthsInspection.type";
import { Uppdrag } from "types/uppdrag.type";
import { usePreviewPdf } from "hooks/usePreviewPdf";
import {
  FilePreviewSmall,
  InspectionPDFPreviewSmall,
  PendingPDFCardSmall,
} from "components/FilePreviewSmall";
import { getFileNameNew } from "helpers/file";
import { Headline5 } from "components/typography/Headline5";
import { InspectionStatus } from "enums/InspectionStatus.enum";

type InspectionItemProps = {
  inspection: SixMonthsInspection | FiveYearsInspection;
  type: InspectionType;
  uppdrag: Uppdrag;
};

export const InspectionItem = ({
  inspection,
  type,
  uppdrag,
}: InspectionItemProps) => {
  const { previewPdf, isLoading } = usePreviewPdf();

  return (
    <div>
      <div className="flex flex-col space-y-2">
        <Headline5 className="mb-2">
          {`${getInspectionName(type)} - ${inspection.separator.identifier}`}
        </Headline5>
        {inspection.status === InspectionStatus.RequirementsFulfilled ? (
          <InspectionPDFPreviewSmall
            onClick={() =>
              previewPdf(
                type === InspectionType.FiveYears
                  ? `/five-years-inspection/${inspection.id}/preview-pdf`
                  : `/six-months-inspection/${inspection.id}/preview-pdf`,
              )
            }
            inspectionName={`${getInspectionName(type).toLocaleLowerCase()}.pdf`}
            isLoading={isLoading}
          />
        ) : (
          <PendingPDFCardSmall
            title="Kontrollrapporten genereras automatiskt"
            subtitle="Slutför besiktningen för att skapa dokumentet"
          />
        )}
        {inspection.files.map((item) => (
          <FilePreviewSmall
            key={item.id}
            url={item.url}
            name={getFileNameNew(item)}
          />
        ))}
      </div>
    </div>
  );
};

const getInspectionName = (type: InspectionType) => {
  switch (type) {
    case InspectionType.FiveYears:
      return "5-årsbesiktning";
    case InspectionType.SixMonths:
      return "6-månaderskontroll";
    default:
      throw Error(
        "getInspectionName is missing implementation for " + type.toString(),
      );
  }
};
